import { ResizeObserver as ResizeObserverPolyfill } from "@juggle/resize-observer";

if (typeof window !== "undefined") {
    window.ResizeObserver = window.ResizeObserver || ResizeObserverPolyfill;
}
